// extracted by mini-css-extract-plugin
export default {"container":"Message_container__UUzzY","right":"Message_right__HWZup","details":"Message_details__sjj0V","messageBody":"Message_messageBody__A4rWS"};